
export type TaxonomyRole = {
    id: string;
    name: string;
    department: string;
    skills: {
        id: string;
        name: string;
        proficiency: number;
    }[];
};

export type TaxonomyData = {
    roles: TaxonomyRole[];
};

export type CompanySector = {
    name: string;
    description?: string;
};

export type CompanySize = {
    range: string;
    description?: string;
};

export type Interest = {
    name: string;
    category: string;
};

// Define mock data for company sectors
export const companySectors: CompanySector[] = [
  { name: 'Technology', description: 'Software, hardware, IT services' },
  { name: 'Finance', description: 'Banking, insurance, investment' },
  { name: 'Healthcare', description: 'Hospitals, pharmaceuticals, medical devices' },
  { name: 'Education', description: 'Schools, universities, educational services' },
  { name: 'Manufacturing', description: 'Production of goods' },
  { name: 'Retail', description: 'Sales of goods to consumers' },
  { name: 'Energy', description: 'Oil, gas, renewables, utilities' },
  { name: 'Telecommunications', description: 'Communication services' },
  { name: 'Media & Entertainment', description: 'Film, music, publishing, broadcasting' },
  { name: 'Transportation & Logistics', description: 'Movement of goods and people' },
  { name: 'Hospitality & Tourism', description: 'Hotels, restaurants, travel' },
  { name: 'Construction', description: 'Building and infrastructure' },
  { name: 'Agriculture', description: 'Farming, forestry, fishing' },
  { name: 'Professional Services', description: 'Legal, consulting, accounting' },
  { name: 'Government', description: 'Public administration' },
  { name: 'Non-Profit', description: 'Charitable organizations' }
];

// Define mock data for company sizes
export const companySizes: CompanySize[] = [
  { range: '1-10 employees', description: 'Micro business' },
  { range: '11-50 employees', description: 'Small business' },
  { range: '51-200 employees', description: 'Medium business' },
  { range: '201-500 employees', description: 'Medium-large business' },
  { range: '501-1,000 employees', description: 'Large business' },
  { range: '1,001-5,000 employees', description: 'Enterprise' },
  { range: '5,001-10,000 employees', description: 'Large enterprise' },
  { range: '10,001+ employees', description: 'Global enterprise' }
];

// Define mock data for role interests
export const roleInterests: Interest[] = [
  { name: 'Software Engineer', category: 'Technology' },
  { name: 'Product Manager', category: 'Product' },
  { name: 'Data Scientist', category: 'Data' },
  { name: 'UX Designer', category: 'Design' },
  { name: 'Financial Analyst', category: 'Finance' },
  { name: 'Marketing Manager', category: 'Marketing' },
  { name: 'Sales Representative', category: 'Sales' },
  { name: 'Human Resources', category: 'HR' },
  { name: 'Customer Support', category: 'Support' },
  { name: 'Operations Manager', category: 'Operations' },
  { name: 'Project Manager', category: 'Management' },
  { name: 'Business Analyst', category: 'Business' },
  { name: 'Content Writer', category: 'Content' },
  { name: 'Legal Counsel', category: 'Legal' },
  { name: 'Executive Assistant', category: 'Administration' }
];


// Define mock data for skill interests
export const skillInterests: Interest[] = [
  { name: 'Programming', category: 'Technical' },
  { name: 'Data Analysis', category: 'Technical' },
  { name: 'Project Management', category: 'Management' },
  { name: 'Marketing', category: 'Business' },
  { name: 'Design', category: 'Creative' },
  { name: 'Communication', category: 'Soft Skills' },
  { name: 'Leadership', category: 'Soft Skills' },
  { name: 'Problem Solving', category: 'Soft Skills' },
  { name: 'Customer Service', category: 'Business' },
  { name: 'Sales', category: 'Business' },
  { name: 'Research', category: 'Technical' },
  { name: 'Writing', category: 'Communication' },
  { name: 'Finance', category: 'Business' },
  { name: 'Accounting', category: 'Business' },
  { name: 'Legal', category: 'Business' },
  { name: 'Human Resources', category: 'Business' }
];

// Define mock data for team/departments
export const teamDepartments: Interest[] = [
  { name: 'Engineering', category: 'Technical' },
  { name: 'Product', category: 'Business' },
  { name: 'Design', category: 'Creative' },
  { name: 'Marketing', category: 'Business' },
  { name: 'Sales', category: 'Business' },
  { name: 'Customer Support', category: 'Service' },
  { name: 'Human Resources', category: 'Administrative' },
  { name: 'Finance', category: 'Administrative' },
  { name: 'Legal', category: 'Administrative' },
  { name: 'Operations', category: 'Business' },
  { name: 'Research & Development', category: 'Technical' },
  { name: 'Information Technology', category: 'Technical' },
  { name: 'Administration', category: 'Administrative' },
  { name: 'Executive', category: 'Management' }
];